export const ENABLE_VIDEO_DELIVERY_FLAG = 'enable_video_delivery';
